"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRef = void 0;
/**
 * Creates a ref object which can contain arbitrary value.
 *
 * @returns - Creates an object with a single property `current` (initially set to `null`).
 */
function createRef() {
    return {
        current: null,
    };
}
exports.createRef = createRef;
//# sourceMappingURL=ref.js.map